import { createFileRoute } from "@tanstack/react-router";

// Mirrors portal's `_protected.$school.lesson.$lesson._index.tsx` (renders nothing). The wizard's
// final redirect and all navigation target `/lesson/$lesson/teacher/*`, so the bare index is unused.
export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lesson/$lesson/",
)({
  component: () => null,
});
